import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { FpModel } from "app/shared/model/fp";
import { ugiftPath } from "app/config/config";
import FingerprintJS, {
  defaultEndpoint,
  defaultScriptUrlPattern,
} from "@fingerprintjs/fingerprintjs-pro";
import { environment } from "environments/environment";
import { detectDeviceInfo } from "app/shared/util/CommonUtil";
import {
  ALLOW_BROWSERS_ANDROID,
  ALLOW_BROWSERS_IOS,
} from "app/shared/consts/app-consts";
import { AppComponent } from "app/app.component";
import { detectIncognito } from "detectincognitojs";

@Injectable({ providedIn: "root" })
export class PC_Browser_Guard implements CanActivate {
  constructor(public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    detectIncognito().then((result) => {
      if (result.isPrivate && environment.isEnableBlockBrowser) {
        this.router.navigate([ugiftPath.browser.path]);
        return false;
      }
    });
    if (AppComponent.isValidateBrowser) {
      detectDeviceInfo((info) => {
        const fpFull: FpModel = JSON.parse(localStorage.getItem("fpFull"));
        if (fpFull?.browserName && fpFull?.os) {
          if (info?.os === "ios") {
            if (
              !ALLOW_BROWSERS_IOS.includes(info?.browserName) &&
              environment.isEnableBlockBrowser
            ) {
              this.router.navigate([ugiftPath.browserIphone.path]);
              return false;
            }
          } else {
            if (info?.os === "android") {
              if (
                !ALLOW_BROWSERS_ANDROID.includes(info?.browserName) &&
                environment.isEnableBlockBrowser
              ) {
                this.router.navigate([ugiftPath.browserAndroid.path]);
                return false;
              }
            } else {
              if (environment.isEnableBlockBrowser) {
                this.router.navigate([ugiftPath.browser.path]);
              }
            }
          }
        }
      });
    }
    return true;
  }
}
